var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"convert-price",style:(_vm.styles)},[(_vm.showIcon)?_c('svg-icon',{attrs:{"iconClass":"shell","size":_vm.iconSize}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.convertPrice))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }